import { FormSection } from '@ksyos/design-system';
import type { ProcessActivityAnamnesis } from '@common/validation/customControls/processActivityAnamnesisData';
import { FormParagraphFormGroup } from '@frontend/components/fields/FormParagraphField';
import { getSelectedLanguage } from '@frontend/translate';

interface ProcessActivityAnamnesisReadProps {
    data: { anamnesis: ProcessActivityAnamnesis };
}

export function ProcessActivityAnamnesisRead(props: ProcessActivityAnamnesisReadProps) {
    const { data } = props;
    const translate = getSelectedLanguage();

    return (
        <FormSection title={translate.anamnesis.anamnesis}>
            <FormParagraphFormGroup label={translate.anamnesis.complaints}>
                {data.anamnesis.complaints}
            </FormParagraphFormGroup>
            <FormParagraphFormGroup label={translate.anamnesis.history}>
                {data.anamnesis.history}
            </FormParagraphFormGroup>
            <FormParagraphFormGroup label={translate.anamnesis.familyHistory}>
                {data.anamnesis.familyHistory}
            </FormParagraphFormGroup>
        </FormSection>
    );
}
